<template>
  <el-form label-width="90px" label-position="left" size="small">
    <el-form-item label="拥有角色：">
      <div class="el-input">{{ showRoles(user.auth_roles) }}</div>
    </el-form-item>
    <el-form-item label="拥有权限：">
      <el-tree
        ref="tree"
        :data="auths"
        :props="defaultProps"
        node-key="code"
        class="permission-tree"
      />
    </el-form-item>
  </el-form>
</template>

<script>
import { authList } from '@/service/getData'
import store from '@/store/store'

export default {
  props: {
    user: {
      type: Object,
    },
  },
  data() {
    return {
      isadealer: store.getters.userInfo.dealer_id > 0,
      auths: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
    }
  },

  watch: {
    user: 'getAuths',
  },

  methods: {
    showRoles(roles) {
      if (!roles) return ''
      let names = roles.map((item) => {
        return item.name
      })
      return names.join(' / ')
    },

    filterTree(tree = [], filterPlatform = 0, arr1 = [], arr2 = []) {
      if (!tree.length) return []
      for (let item of tree) {
        if (
          item.platform == filterPlatform ||
          item.platform == 3 ||
          item.platform == -1
        )
          continue
        let node = { ...item, children: [] }
        if (item.codes[0]) {
          node.code = item.codes[0]
          if (
            this.user.auth_codes.includes(node.code) ||
            this.user.is_super_admin
          ) {
            arr1.push(node)
          }
        }

        let node1 = { ...item, children: [] }
        if (item.codes[1]) {
          node1.code = item.codes[1]
          if (
            this.user.auth_codes.includes(node1.code) ||
            this.user.is_super_admin
          ) {
            arr2.push(node1)
          }
        }

        if (item.children && item.children.length)
          this.filterTree(
            item.children,
            filterPlatform,
            node.children,
            node1.children
          )
      }
      return [arr1, arr2]
    },

    async getAuths() {
      let res = await authList()
      if (res.code == 0) {
        let auths = this.filterTree(res.data.list, this.isadealer ? 1 : 2)

        this.auths = [
          { name: 'PC端', code: '100000', children: auths[0] },
          { name: '移动端', code: '200000', children: auths[1] },
        ]
      }
    },
  },
}
</script>
<style scoped>
.permission-tree {
  background: none;
  left: -9px;
}
</style>